import { Component, OnInit, Input } from '@angular/core';
import { Meal } from 'src/models/meal';

@Component({
  selector: 'app-meal-list-item',
  templateUrl: './meal-list-item.component.html',
  styleUrls: ['./meal-list-item.component.scss']
})
export class MealListItemComponent implements OnInit {

  @Input() meal: Meal;

  constructor() { }

  ngOnInit(): void {
  }

}
